<template>

    <trax-ui-ajax-table-with-crud-actions 
        :id="id" :titles="titles" :props="props" :bus="bus" 
        :endpoint="endpoint" :edit-url="edit_url">
    </trax-ui-ajax-table-with-crud-actions>
    
</template>

<script>
    export default {
    
        props: ['bus'],

        data: function() {
            return {
                endpoint: app_url+"trax/api/front/roles",
                edit_url: app_url+"polaris/ui/account/role/edit",
                titles: [
                    lang.polaris.form.name,
                    lang.polaris.form.description,
                    ''
                ],
                props: [
                    {source: 'name', class: 'font-weight-bold'},
                    {source: 'description', width: '75%', truncate: 150}
                ],
                id: 'trax-account-role'
            }
        }
    }
</script>
